<template>
  <div class="tag-input form-control" tabindex="0" v-if="hasTag">
    <span class="tag">{{value}}<a href="javascript:" @click="removeTag"><span class="fas fa-times"></span></a></span>
  </div>
  <input type="text" class="form-control" @input="updateValue($event.target.value)" @keydown="$emit('keydown', $event)" @keyup="$emit('keyup', $event)" ref="input"
         :value="value" v-else>
</template>

<script>
  export default {
    methods: {
      removeTag () {
        this.$emit('remove-tag')
      },
      updateValue (val) {
        this.$refs.input.value = val
        this.$emit('input', val)
      }
    },
    props: {
      hasTag: {
        type: Boolean,
        default: false
      },
      value: String
    }
  }
</script>

<style lang="scss">
  @import '@/sass/variables.scss';

  .tag-input {
    cursor: text;
    padding-left: .375rem;

    &:focus {
      border-color: #80bdff;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
      outline: 0;
    }

    .tag {
      color: #FFF;
      background: $cyan;
      border-radius: .25rem;
      padding: .1875rem .375rem;

      a {
        color: #FFF;
        margin-left: .75rem;
      }
    }
  }
</style>
